<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="query"></v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="query"
            >Outwards Treaty
            <v-btn text color="primary" @click="query = false" v-if="query">
              Edit
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title v-else>Outwards Treaty </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="noRiskArea"
                  v-model="miscTtyForm.noRiskArea"
                  :label="labels.noRiskArea"
                  item-text="label"
                  item-value="value"
                  data-vv-name="noRiskArea"
                  :data-vv-as="labels.noRiskArea"
                  :error-messages="errors.collect('noRiskArea')"
                  v-validate="'required'"
                  @change="checkNoRiskArea"
                  :disabled="query"
                ></v-autocomplete>
                <!-- <v-text-field v-model="miscTtyForm.noRiskArea" type="number" :label="labels.noRiskArea" :error-messages="errors.collect('noRiskArea')" data-vv-name="noRiskArea" :data-vv-as="labels.noRiskArea" v-validate="'required|numeric|min_value:0|max_value:9'"  :disabled="query"></v-text-field> -->
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="miscTtyForm.sepAcctArea"
                  :label="labels.sepAcctArea"
                  :error-messages="errors.collect('sepAcctArea')"
                  data-vv-name="sepAcctArea"
                  :data-vv-as="labels.sepAcctArea"
                  :disabled="query || this.miscTtyForm.noRiskArea === 1"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.nxtOutwTranRef"
                  :label="labels.nxtOutwTranRef"
                  :error-messages="errors.collect('nxtOutwTranRef')"
                  data-vv-name="nxtOutwTranRef"
                  :data-vv-as="labels.nxtOutwTranRef"
                  v-validate="'required'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="miscTtyForm.sepDRIAcct"
                  :label="labels.sepDRIAcct"
                  :error-messages="errors.collect('sepAcctArea')"
                  data-vv-name="sepAcctArea"
                  :data-vv-as="labels.sepAcctArea"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.mthlySumStmtClCut"
                  :label="labels.mthlySumStmtClCut"
                  :error-messages="errors.collect('mthlySumStmtClCut')"
                  data-vv-name="mthlySumStmtClCut"
                  :data-vv-as="labels.mthlySumStmtClCut"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @input="doStmtType('mthlySumStmtClCut')"
                  @click:append="getHelpList('mthlySumStmtClCut')"
                  :hint="this.miscTtyForm.mthlySumStmtClCutDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.mthlySumStmtROff"
                  :label="labels.mthlySumStmtROff"
                  :error-messages="errors.collect('mthlySumStmtROff')"
                  data-vv-name="mthlySumStmtROff"
                  :data-vv-as="labels.mthlySumStmtROff"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('mthlySumStmtROff')"
                  :hint="this.miscTtyForm.mthlySumStmtROffDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.qrtlySumStmtClCut"
                  :label="labels.qrtlySumStmtClCut"
                  :error-messages="errors.collect('qrtlySumStmtClCut')"
                  data-vv-name="qrtlySumStmtClCut"
                  :data-vv-as="labels.qrtlySumStmtClCut"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('qrtlySumStmtClCut')"
                  :hint="this.miscTtyForm.qrtlySumStmtClCutDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.qrtlySumStmtROff"
                  :label="labels.qrtlySumStmtROff"
                  :error-messages="errors.collect('qrtlySumStmtROff')"
                  data-vv-name="qrtlySumStmtROff"
                  :data-vv-as="labels.qrtlySumStmtROff"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('qrtlySumStmtROff')"
                  :hint="this.miscTtyForm.qrtlySumStmtROffDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.premStmtLnType"
                  :label="labels.premStmtLnType"
                  :error-messages="errors.collect('premStmtLnType')"
                  data-vv-name="premStmtLnType"
                  :data-vv-as="labels.premStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('premStmtLnType')"
                  :hint="this.miscTtyForm.premStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.comm1StmtLnType"
                  :label="labels.comm1StmtLnType"
                  :error-messages="errors.collect('comm1StmtLnType')"
                  data-vv-name="comm1StmtLnType"
                  :data-vv-as="labels.comm1StmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('comm1StmtLnType')"
                  :hint="this.miscTtyForm.comm1StmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.comm2StmtLnType"
                  :label="labels.comm2StmtLnType"
                  :error-messages="errors.collect('comm2StmtLnType')"
                  data-vv-name="comm2StmtLnType"
                  :data-vv-as="labels.comm2StmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('comm2StmtLnType')"
                  :hint="this.miscTtyForm.comm2StmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.profCommStmtLnType"
                  :label="labels.profCommStmtLnType"
                  :error-messages="errors.collect('profCommStmtLnType')"
                  data-vv-name="profCommStmtLnType"
                  :data-vv-as="labels.profCommStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('profCommStmtLnType')"
                  :hint="this.miscTtyForm.profCommStmtLnTypeDesc"
                  persistent-hint
                  :disabled="true"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.supProfCommStmtLnType"
                  :label="labels.supProfCommStmtLnType"
                  :error-messages="errors.collect('supProfCommStmtLnType')"
                  data-vv-name="supProfCommStmtLnType"
                  :data-vv-as="labels.supProfCommStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('supProfCommStmtLnType')"
                  :hint="this.miscTtyForm.supProfCommStmtLnTypeDesc"
                  persistent-hint
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.clmPaytStmtLnType"
                  :label="labels.clmPaytStmtLnType"
                  :error-messages="errors.collect('clmPaytStmtLnType')"
                  data-vv-name="clmPaytStmtLnType"
                  :data-vv-as="labels.clmPaytStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmPaytStmtLnType')"
                  :hint="this.miscTtyForm.clmPaytStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.clmCshCallStmtLnType"
                  :label="labels.clmCshCallStmtLnType"
                  :error-messages="errors.collect('clmCshCallStmtLnType')"
                  data-vv-name="clmCshCallStmtLnType"
                  :data-vv-as="labels.clmCshCallStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmCshCallStmtLnType')"
                  :hint="this.miscTtyForm.clmCshCallStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.clmResStmtLnType"
                  :label="labels.clmResStmtLnType"
                  :error-messages="errors.collect('clmResStmtLnType')"
                  data-vv-name="clmResStmtLnType"
                  :data-vv-as="labels.clmResStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmResStmtLnType')"
                  :hint="this.miscTtyForm.clmResStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.premRetRelStmtLnType"
                  :label="labels.premRetRelStmtLnType"
                  :error-messages="errors.collect('premRetRelStmtLnType')"
                  data-vv-name="premRetRelStmtLnType"
                  :data-vv-as="labels.premRetRelStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('premRetRelStmtLnType')"
                  :hint="this.miscTtyForm.premRetRelStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.taxStmtLnType"
                  :label="labels.taxStmtLnType"
                  :error-messages="errors.collect('taxStmtLnType')"
                  data-vv-name="taxStmtLnType"
                  :data-vv-as="labels.taxStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('taxStmtLnType')"
                  :hint="this.miscTtyForm.taxStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.intStmtLnType"
                  :label="labels.intStmtLnType"
                  :error-messages="errors.collect('intStmtLnType')"
                  data-vv-name="intStmtLnType"
                  :data-vv-as="labels.intStmtLnType"
                  v-validate="'entry'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('intStmtLnType')"
                  :hint="this.miscTtyForm.intStmtLnTypeDesc"
                  persistent-hint
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6> </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.minDaysLongTermPol"
                  :label="labels.minDaysLongTermPol"
                  :error-messages="errors.collect('minDaysLongTermPol')"
                  data-vv-name="minDaysLongTermPol"
                  :data-vv-as="labels.minDaysLongTermPol"
                  v-validate="'required|checkMinDayLongTerm'"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.perSuspTran"
                  v-model="miscTtyForm.perSuspTran"
                  :error-messages="errors.collect('perSuspTran')"
                  data-vv-name="perSuspTran"
                  :data-vv-as="labels.perSuspTran"
                  v-validate="'checkPerTran'"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.perDebtTran"
                  v-model="miscTtyForm.perDebtTran"
                  :error-messages="errors.collect('perDebtTran')"
                  data-vv-name="perDebtTran"
                  :data-vv-as="labels.perDebtTran"
                  v-validate="'checkPerTran'"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="defTranList"
                  v-model="miscTtyForm.defTran"
                  :label="labels.defTran"
                  item-text="label"
                  item-value="value"
                  data-vv-name="defTran"
                  :data-vv-as="labels.defTran"
                  :error-messages="errors.collect('defTran')"
                  v-validate="'required|checkDefTran'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.latestTtyYr"
                  :label="labels.latestTtyYr"
                  type="number"
                  :error-messages="errors.collect('latestTtyYr')"
                  data-vv-name="latestTtyYr"
                  :data-vv-as="labels.latestTtyYr"
                  :min="0"
                  :max="15"
                  v-validate="{ required: true, mask_min_value: 0, mask_max_value: 15 }"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="ttyYrTypeList"
                  v-model="miscTtyForm.ttyYrType"
                  :label="labels.ttyYrType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="ttyYrType"
                  :data-vv-as="labels.ttyYrType"
                  :error-messages="errors.collect('ttyYrType')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.nxtBchMchGLOutw"
                  :label="labels.nxtBchMchGLOutw"
                  type="number"
                  :error-messages="errors.collect('nxtBchMchGLOutw')"
                  data-vv-name="nxtBchMchGLOutw"
                  :data-vv-as="labels.nxtBchMchGLOutw"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="miscTtyForm.nxtBchRevGLOutw"
                  :label="labels.nxtBchRevGLOutw"
                  type="number"
                  :error-messages="errors.collect('nxtBchRevGLOutw')"
                  data-vv-name="nxtBchRevGLOutw"
                  :data-vv-as="labels.nxtBchRevGLOutw"
                  :disabled="query"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="busAnAutoGenMethList"
                  v-model="miscTtyForm.busAnAutoGenMeth"
                  :label="labels.busAnAutoGenMeth"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busAnAutoGenMeth"
                  :data-vv-as="labels.busAnAutoGenMeth"
                  :error-messages="errors.collect('busAnAutoGenMeth')"
                  v-validate="'required'"
                  :disabled="query"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.statyAsTty"
                  v-model="miscTtyForm.statyAsTty"
                  :error-messages="errors.collect('statyAsTty')"
                  data-vv-name="statyAsTty"
                  :data-vv-as="labels.statyAsTty"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  :label="labels.upldStaty"
                  v-model="miscTtyForm.upldStaty"
                  :error-messages="errors.collect('upldStaty')"
                  data-vv-name="upldStaty"
                  :data-vv-as="labels.upldStaty"
                  :disabled="query"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-divider class="pt-3"></v-divider>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ miscTtyForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDate(miscTtyForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!query">
          <v-btn color="error" @click="queryModeSwitch" :loading="submitting"> Cancel<v-icon right dark>mdi-cancel</v-icon> </v-btn>
          <v-btn color="primary" dark @click="doSave" :loading="submitting"> Save Parameters<v-icon right>mdi-content-save</v-icon> </v-btn>
        </v-card-actions>
        <v-dialog v-model="helplist" width="900px" persistent>
          <!-- Helplist component -->
          <stmtLnType-help-list
            :mode="mode"
            :param="param"
            v-if="stmtLnTypeHelplist"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></stmtLnType-help-list>
          <!-- <stmtLnType-help-list v-if="stmtLnTypeHelplist" @close="doClose" @selectStmtLnType="doAssignStmtLnType($event)"></stmtLnType-help-list> -->
          <stmtType-byDebtTypeS-help-list
            v-if="stmtTypeByDebtTypeSHelplist"
            @close="doClose"
            @selectStmtType="doAssignStmtType($event)"
          ></stmtType-byDebtTypeS-help-list>
          <stmtType-help-list v-if="stmtTypeHelplist" @close="doClose" @selectStmtType="doAssignStmtType($event)"></stmtType-help-list>
        </v-dialog>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { acctType } from '@/const/params'
import StmtLnTypeHelplist from './helplist/StmtLnTypeHelplist.vue'
import StmtTypeByDebtTypeSHelplist from './helplist/StmtTypeByDebtTypeSHelplist.vue'
import StmtTypeHelplist from './helplist/StmtTypeHelplist.vue'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
export default {
  data() {
    return {
      selectHelplist: undefined,
      helplist: false,
      stmtLnTypeHelplist: false,
      stmtTypeByDebtTypeSHelplist: false,
      stmtTypeHelplist: false,
      labels: {
        noRiskArea: 'No. of RIsk Areas',
        sepAcctArea: 'Separate Accounts each Risk Area',
        nxtOutwTranRef: 'Next Outwards Transaction Reference',
        sepDRIAcct: 'D/RI Split in Outwards Treaty GL',
        mthlySumStmtClCut: 'Statement Type for Monthly Upload – Clean-Cut',
        mthlySumStmtROff: 'Statement Type for Monthly Upload – Run-Off',
        qrtlySumStmtClCut: 'Statement Type for Quarterly Etc Summary Upload – CleanCut',
        qrtlySumStmtROff: 'Statement Type for Quarterly Etc Summary Upload – Run-Off',
        premStmtLnType: 'Statement Line Type for Premium Upload',
        comm1StmtLnType: 'Statement Line Type for Commission 1 Upload',
        comm2StmtLnType: 'Statement Line Type for Commission 2 Upload',
        profCommStmtLnType: 'Statement Line Type for Profit Commission Upload',
        supProfCommStmtLnType: 'Statement Line Type for Super Profit Commission Upload',
        clmPaytStmtLnType: 'Statement Line Type for Claims Payment Upload',
        clmCshCallStmtLnType: 'Statement Line Type for Claims Cash Call Upload',
        clmResStmtLnType: 'Statement Line Type for Claims Reserve Upload',
        premRetRelStmtLnType: 'Statement Line Type for Premium Retain / Release',
        taxStmtLnType: 'Statement Line Type for Tax',
        intStmtLnType: 'Statement Line Type for Interest',
        minDaysLongTermPol: 'Minimum Days in Long Term Policy',
        perSuspTran: 'Permit Suspense Transaction Entry',
        perDebtTran: 'Permit Debtor Transaction Entry',
        defTran: 'Default Debtor or Suspense on Entry',
        latestTtyYr: 'Latest Treaty Year for Upload',
        ttyYrType: 'Treaty Year by Policy Type or Treaty Parameters',
        nxtBchMchGLOutw: 'Next Batch Matched GL Update – Outwards',
        nxtBchRevGLOutw: 'Next Batch Revalued GL Update – Outwards',
        busAnAutoGenMeth: 'Business Analysis Code Auto Generate Method',
        statyAsTty: 'Process Statutory as Treaty',
        upldStaty: 'Upload Statutory to Treaty Module',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      miscTtyForm: {
        noRiskArea: 1,
        sepAcctArea: false,
        nxtOutwTranRef: 1,
        sepDRIAcct: true,
        mthlySumStmtClCut: undefined,
        mthlySumStmtClCutDesc: undefined,
        mthlySumStmtROff: undefined,
        mthlySumStmtROffDesc: undefined,
        qrtlySumStmtClCut: undefined,
        qrtlySumStmtClCutDesc: undefined,
        qrtlySumStmtROff: undefined,
        qrtlySumStmtROffDesc: undefined,
        premStmtLnType: undefined,
        premStmtLnTypeDesc: undefined,
        comm1StmtLnType: undefined,
        comm1StmtLnTypeDesc: undefined,
        comm2StmtLnType: undefined,
        comm2StmtLnTypeDesc: undefined,
        profCommStmtLnType: undefined,
        profCommStmtLnTypeDesc: undefined,
        supProfCommStmtLnType: undefined,
        supProfCommStmtLnTypeDesc: undefined,
        clmPaytStmtLnType: undefined,
        clmPaytStmtLnTypeDesc: undefined,
        clmCshCallStmtLnType: undefined,
        clmCshCallStmtLnTypeDesc: undefined,
        clmResStmtLnType: undefined,
        clmResStmtLnTypeDesc: undefined,
        premRetRelStmtLnType: undefined,
        premRetRelStmtLnTypeDesc: undefined,
        taxStmtLnType: undefined,
        taxStmtLnTypeDesc: undefined,
        intStmtLnType: undefined,
        intStmtLnTypeDesc: undefined,
        minDaysLongTermPol: 547,
        perSuspTran: true,
        perDebtTran: true,
        defTran: undefined,
        latestTtyYr: 0,
        ttyYrType: 0,
        nxtBchMchGLOutw: 0,
        nxtBchRevGLOutw: 0,
        busAnAutoGenMeth: 1,
        statyAsTty: undefined,
        upldStaty: undefined,
        modifiedName: this.$store.state.token.firstName,
        modifiedDate: new Date()
      },
      noRiskArea: [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 }
      ],
      prtILNList: [
        { label: 'I - Immediate', value: 'I' },
        { label: 'L - Later', value: 'L' },
        { label: 'N - No', value: 'N' }
      ],
      qrtlySumStmtClCutList: [
        { label: 'P - Payment Voucher Date', value: 'P' },
        { label: 'S - System Date', value: 'S' }
      ],
      comm2StmtLnTypeList: [
        { label: '1 - None', value: '1' },
        { label: '2 - Warning', value: '2' },
        { label: '3 - Error', value: '3' }
      ],
      defTranList: [
        { label: 'D - Debtor', value: 'D' },
        { label: 'S - Suspense', value: 'S' }
      ],
      ttyYrTypeList: [
        { label: 'P - Policy Type', value: 'P' },
        { label: 'T - Treaty Parameters', value: 'T' }
      ],
      busAnAutoGenMethList: [
        { label: '1 - Class related', value: 1 },
        { label: '2 - Class, Policy Type, D/RI', value: 2 }
      ],
      clmnoform: [],
      today: new Date(),
      submitting: false,
      query: true,
      tempStorage: [],
      param: '',
      mode: ''
    }
  },
  methods: {
    async doInit() {
      this.$store.dispatch('stmtTypeManagementInit')
      const apiURI = this.menu.getMiscTreatyParam
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.miscTtyForm.noRiskArea = data.miscTreatyParam.noRiskArea
            this.miscTtyForm.sepAcctArea = data.miscTreatyParam.sepAcctArea
            this.miscTtyForm.nxtOutwTranRef = data.miscTreatyParam.nxtOutwTranRef
            this.miscTtyForm.sepDRIAcct = data.miscTreatyParam.sepDRIAcct
            this.miscTtyForm.mthlySumStmtClCut = data.miscTreatyParam.mthlySumStmtClCut
            this.miscTtyForm.mthlySumStmtROff = data.miscTreatyParam.mthlySumStmtROff
            this.miscTtyForm.qrtlySumStmtClCut = data.miscTreatyParam.qrtlySumStmtClCut
            this.miscTtyForm.qrtlySumStmtROff = data.miscTreatyParam.qrtlySumStmtROff
            this.miscTtyForm.premStmtLnType = data.miscTreatyParam.premStmtLnType
            this.miscTtyForm.comm1StmtLnType = data.miscTreatyParam.comm1StmtLnType
            this.miscTtyForm.comm2StmtLnType = data.miscTreatyParam.comm2StmtLnType
            this.miscTtyForm.profCommStmtLnType = data.miscTreatyParam.profCommStmtLnType
            this.miscTtyForm.supProfCommStmtLnType = data.miscTreatyParam.supProfCommStmtLnType
            this.miscTtyForm.clmPaytStmtLnType = data.miscTreatyParam.clmPaytStmtLnType
            this.miscTtyForm.clmCshCallStmtLnType = data.miscTreatyParam.clmCshCallStmtLnType
            this.miscTtyForm.clmResStmtLnType = data.miscTreatyParam.clmResStmtLnType
            this.miscTtyForm.premRetRelStmtLnType = data.miscTreatyParam.premRetRelStmtLnType
            this.miscTtyForm.taxStmtLnType = data.miscTreatyParam.taxStmtLnType
            this.miscTtyForm.intStmtLnType = data.miscTreatyParam.intStmtLnType
            this.miscTtyForm.minDaysLongTermPol = data.miscTreatyParam.minDaysLongTermPol
            this.miscTtyForm.perSuspTran = data.miscTreatyParam.perSuspTran
            this.miscTtyForm.perDebtTran = data.miscTreatyParam.perDebtTran
            this.miscTtyForm.defTran = data.miscTreatyParam.defTran
            this.miscTtyForm.latestTtyYr = data.miscTreatyParam.latestTtyYr
            this.miscTtyForm.ttyYrType = data.miscTreatyParam.ttyYrType
            this.miscTtyForm.nxtBchMchGLOutw = data.miscTreatyParam.nxtBchMchGLOutw
            this.miscTtyForm.nxtBchRevGLOutw = data.miscTreatyParam.nxtBchRevGLOutw
            this.miscTtyForm.busAnAutoGenMeth = parseInt(data.miscTreatyParam.busAnAutoGenMeth)
            this.miscTtyForm.upldStaty = data.miscTreatyParam.upldStaty
            this.miscTtyForm.statyAsTty = data.miscTreatyParam.statyAsTty
            this.miscTtyForm.modifiedName = data.miscTreatyParam.modifiedName
            this.miscTtyForm.modifiedDate = data.miscTreatyParam.modifiedDate
          }
          this.tempStorage = clone(this.miscTtyForm)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          const apiURI = this.menu.saveMiscTreatyParam
          if (apiURI) {
            this.$http
              .post(apiURI, this.miscTtyForm)
              .then((result) => {
                const { data } = result
                if (data) {
                  this.notify(data)
                  this.doInit()
                }
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    checkNoRiskArea() {
      if (this.miscTtyForm.noRiskArea === 1) {
        this.miscTtyForm.sepAcctArea = false
      }
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'stmtLnType') {
        this.stmtLnTypeHelplist = true
      } else if (fieldname === 'mthlySumStmtClCut') {
        this.selectHelplist = 'mthlySumStmtClCut'
        this.stmtTypeByDebtTypeSHelplist = true
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = false
      } else if (fieldname === 'mthlySumStmtROff') {
        this.selectHelplist = 'mthlySumStmtROff'
        this.stmtTypeByDebtTypeSHelplist = true
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = false
      } else if (fieldname === 'qrtlySumStmtClCut') {
        this.selectHelplist = 'qrtlySumStmtClCut'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = true
        this.stmtLnTypeHelplist = false
      } else if (fieldname === 'qrtlySumStmtROff') {
        this.selectHelplist = 'qrtlySumStmtROff'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = true
        this.stmtLnTypeHelplist = false
      } else if (fieldname === 'premStmtLnType') {
        this.selectHelplist = 'premStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.premStmtLnType
      } else if (fieldname === 'comm1StmtLnType') {
        this.selectHelplist = 'comm1StmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.comm1StmtLnType
      } else if (fieldname === 'comm2StmtLnType') {
        this.selectHelplist = 'comm2StmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.comm2StmtLnType
      } else if (fieldname === 'profCommStmtLnType') {
        this.selectHelplist = 'profCommStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.profCommStmtLnType
      } else if (fieldname === 'supProfCommStmtLnType') {
        this.selectHelplist = 'supProfCommStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.supProfCommStmtLnType
      } else if (fieldname === 'clmPaytStmtLnType') {
        this.selectHelplist = 'clmPaytStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.clmPaytStmtLnType
      } else if (fieldname === 'clmCshCallStmtLnType') {
        this.selectHelplist = 'clmCshCallStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.clmCshCallStmtLnType
      } else if (fieldname === 'clmResStmtLnType') {
        this.selectHelplist = 'clmResStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.clmResStmtLnType
      } else if (fieldname === 'premRetRelStmtLnType') {
        this.selectHelplist = 'premRetRelStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.premRetRelStmtLnType
      } else if (fieldname === 'taxStmtLnType') {
        this.selectHelplist = 'taxStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.taxStmtLnType
      } else if (fieldname === 'intStmtLnType') {
        this.selectHelplist = 'intStmtLnType'
        this.stmtTypeByDebtTypeSHelplist = false
        this.stmtTypeHelplist = false
        this.stmtLnTypeHelplist = true
        this.param = this.miscTtyForm.intStmtLnType
      }
    },
    doAssignStmtType(stmtType) {
      if (this.selectHelplist === 'mthlySumStmtClCut') {
        this.miscTtyForm.mthlySumStmtClCut = stmtType.stmtType
        this.miscTtyForm.mthlySumStmtClCutDesc = stmtType.stmtTypeDesc
      } else if (this.selectHelplist === 'mthlySumStmtROff') {
        this.miscTtyForm.mthlySumStmtROff = stmtType.stmtType
        this.miscTtyForm.mthlySumStmtROffDesc = stmtType.stmtTypeDesc
      } else if (this.selectHelplist === 'qrtlySumStmtClCut') {
        this.miscTtyForm.qrtlySumStmtClCut = stmtType.stmtType
        this.miscTtyForm.qrtlySumStmtClCutDesc = stmtType.stmtTypeDesc
      } else if (this.selectHelplist === 'qrtlySumStmtROff') {
        this.miscTtyForm.qrtlySumStmtROff = stmtType.stmtType
        this.miscTtyForm.qrtlySumStmtROffDesc = stmtType.stmtTypeDesc
      }
    },
    doAssignStmtLnType(stmtLnType) {
      // doAssignStmtLnType
      if (this.selectHelplist === 'premStmtLnType') {
        this.miscTtyForm.premStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.premStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'comm1StmtLnType') {
        this.miscTtyForm.comm1StmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.comm1StmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'comm2StmtLnType') {
        this.miscTtyForm.comm2StmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.comm2StmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'profCommStmtLnType') {
        this.miscTtyForm.profCommStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.profCommStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'supProfCommStmtLnType') {
        this.miscTtyForm.supProfCommStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.supProfCommStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'clmPaytStmtLnType') {
        this.miscTtyForm.clmPaytStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.clmPaytStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'clmCshCallStmtLnType') {
        this.miscTtyForm.clmCshCallStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.clmCshCallStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'clmResStmtLnType') {
        this.miscTtyForm.clmResStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.clmResStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'premRetRelStmtLnType') {
        this.miscTtyForm.premRetRelStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.premRetRelStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'taxStmtLnType') {
        this.miscTtyForm.taxStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.taxStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      } else if (this.selectHelplist === 'intStmtLnType') {
        this.miscTtyForm.intStmtLnType = stmtLnType.stmtLnType
        this.miscTtyForm.intStmtLnTypeDesc = stmtLnType.stmtLnTypeDesc
      }
    },
    doAssign(Obj) {
      switch (this.selectHelplist) {
        case 'premStmtLnType':
          this.miscTtyForm.premStmtLnType = ''
          this.miscTtyForm.premStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'comm1StmtLnType':
          this.miscTtyForm.comm1StmtLnType = ''
          this.miscTtyForm.comm1StmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'comm2StmtLnType':
          this.miscTtyForm.comm2StmtLnType = ''
          this.miscTtyForm.comm2StmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'profCommStmtLnType':
          this.miscTtyForm.profCommStmtLnType = ''
          this.miscTtyForm.profCommStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'supProfCommStmtLnType':
          this.miscTtyForm.supProfCommStmtLnType = ''
          this.miscTtyForm.supProfCommStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'clmPaytStmtLnType':
          this.miscTtyForm.clmPaytStmtLnType = ''
          this.miscTtyForm.clmPaytStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'clmCshCallStmtLnType':
          this.miscTtyForm.clmCshCallStmtLnType = ''
          this.miscTtyForm.clmCshCallStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'clmResStmtLnType':
          this.miscTtyForm.clmResStmtLnType = ''
          this.miscTtyForm.clmResStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'premRetRelStmtLnType':
          this.miscTtyForm.premRetRelStmtLnType = ''
          this.miscTtyForm.premRetRelStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'taxStmtLnType':
          this.miscTtyForm.taxStmtLnType = ''
          this.miscTtyForm.taxStmtLnType = Obj.finalSelectedItems.toString()
          break
        case 'intStmtLnType':
          this.miscTtyForm.intStmtLnType = ''
          this.miscTtyForm.intStmtLnType = Obj.finalSelectedItems.toString()
          break
      }
    },
    doStmtType(fieldName) {},
    doClose() {
      this.resetMessages()
      this.helplist = false
      setTimeout(() => {
        this.stmtLnTypeHelplist = false
        this.stmtTypeHelplist = false
      }, 500)
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    padString(value) {
      if (value) {
        return value.toString().padStart(4, '0')
      } else {
        return value
      }
    },
    async queryModeSwitch() {
      if (this.query === false) {
        this.toggleToTempStorage()
        this.query = true
      } else {
        this.query = false
      }
    },
    async toggleToTempStorage() {
      this.miscTtyForm = this.tempStorage
      this.doInit()
    }
  },
  computed: {
    menu() {
      return this.$store.state.miscParams.menu
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  created() {
    const checkDate = {
      getMessage: (field, args) => {
        return field + ' cannot be a future date'
      },
      validate: (value, args) => {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date())) // || removeTime(value) >= removeTime(new Date())
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkDate', checkDate)

    const checkMinDayLongTerm = {
      getMessage: (field, args) => {
        return field + ' cannot be less than 367.'
      },
      validate: (value, args) => {
        if (value) {
          // return value < 367
          return value > 367
        }
      }
    }
    this.$validator.extend('checkMinDayLongTerm', checkMinDayLongTerm)

    const checkPerTran = {
      getMessage: (field, args) => {
        return 'Must permit Debtor or Suspense transaction entry'
      },
      validate: (value, args) => {
        return !(this.miscTtyForm.perSuspTran === false && this.miscTtyForm.perDebtTran === false)
      }
    }
    this.$validator.extend('checkPerTran', checkPerTran)

    const checkDefTran = {
      getMessage: (field, args) => {
        if (this.miscTtyForm.defTran === 'D' && this.miscTtyForm.perDebtTran === false) {
          return 'Cannot be D if Permit Debtor Transaction is No.'
        } else if (this.miscTtyForm.defTran === 'S' && this.miscTtyForm.perSuspTran === false) {
          return 'Cannot be S if Permit Suspense Transaction is No.'
        } else {
          return 'Please Permit Debtor or Suspense Transaction Entry'
        }
      },
      validate: (value, args) => {
        if (this.miscTtyForm.defTran === 'D') {
          return !this.miscTtyForm.perDebtTran === false
        } else {
          return !this.miscTtyForm.perSuspTran === false
        }
      }
    }
    this.$validator.extend('checkDefTran', checkDefTran)
  },
  mixins: [MessageMixin, commonMixins, commonAjaxMixin],
  components: {
    'stmtLnType-help-list': StmtLnTypeHelplist,
    'stmtType-byDebtTypeS-help-list': StmtTypeByDebtTypeSHelplist,
    'stmtType-help-list': StmtTypeHelplist
  }
}
</script>

<style>
</style>
